<template>
  <Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
  >
    <template slot="header">
      {{$t('add_release')}}
    </template>
    <template slot="body">
      <SearchList
        :id="'release'"
        :items="items.map((e)=>{
            return {
              release_id:e.release_id,
              release_artist:e.release_artist +' - '+e.release_title
            }
        })"
        :keyProperty="'release_id'"
        :label="'release_artist'"
        :placeholder="'Search Releases'"
        @searched="onReleaseSearched"
        @selected="onReleaseSelected"
      />
  
    </template>
    <template slot="options">
        <button class="dt-button s7" @click="onCancelClick">{{$t('cancel')}}</button>
        <button class="dt-button s7 v1" @click="onOKClicked">{{$t('add_release')}}</button>
    </template>
  </Modal>
</template>

<script>
import * as R from "ramda";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import {
  BookingStoreNamespace as storeNS,
  BookingStoreNamespace
} from "../../store";
import * as ActionTypes from "../../store/types";

import { addRemoveSet } from "../../../../utility";
import InputField from "../../../../plugins/text-field/input-field";
import { waitForAnimation, subscribeSubject } from "@/utility";
import Modal from '../../../../dt-plugins/modal/modal';
import SearchList from "@dtplugins/search-list/search-list";
import { releaseService } from '../../services/releases/releases.services';
import { artistsService } from '../../services/artists/artists.service';

export default {
  components: {
    InputField,
    Modal,
    SearchList
  },
  props: {

  },
  data: function() {
    return {
      releases: [],
      searchString: "",
      selectedRelease: new Set(),
      searchSubject$: new Subject(),
      releaseSearchResult:[],
    };
  },
  computed: {

    external_id: function() {
      return this.$route.query.external_id;
    },
    items:function(){
        return (this.searchString.length>0)?this.releaseSearchResult:this.releases
    }
  },
  mounted:async function() {
 
    
    const releasesResponse = await artistsService.unrelatedReleases(this.external_id);

    this.releases=releasesResponse.data.unrelated_releases;

        subscribeSubject(this, this.searchSubject$, searchString => {
        
        artistsService.searchUnrelatedReleases(searchString,this.external_id).then(res=>{
            console.log("WERE",this.releaseSearchResult);
            this.releaseSearchResult=res.data.releaseSearchResult;

        });

        // releaseService.searchUnrelatedArtists(this.external_id,searchString).then(res=>{
        //     console.warn(searchString,res);
        //     this.releaseSearchResult=res.data.releases
        // })
        
       
      })
  },
  methods: {
    onOKClicked: function() {

    
      const oneArray=[
        ...Array(Array.from(this.selectedRelease).length).keys(),
      ].map((e) => 1);
     
     console.warn(Array.from(this.selectedRelease).join(","),oneArray.join(","));

    const payload={ releases:Array.from(this.selectedRelease).join(","),release_ids:oneArray.join(",")}
     this.$emit("create",payload)
    },
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
    onCheckboxChange: function(event, artist) {
      this.selectedRelease = addRemoveSet(
        event.target.checked,
        this.selectedRelease,
        artist.artist_id
      );
    },
    onReleaseSelected: function(selectedRelease) {
      console.log("TTT",selectedRelease)
      this.selectedRelease = selectedRelease;
    },
    onReleaseSearched: function(searchString) {
        artistsService.searchUnrelatedReleases(searchString,this.external_id).then(res=>{
            this.searchString=searchString;
            this.releaseSearchResult=res.data.unrelated_releases;
             console.log("WERE",this.releaseSearchResult);

        });
    },
    onSearchInputKeyup: function(event) {
      this.searchString = event.target.value;
      this.searchSubject$.next(event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.releases-container {
  height: 360px;
  overflow: auto;
  border: 1px solid var(--sprt-5);
  .releases {
    .artist-item {
      padding: 5px;

      .checkbox-container {
        padding: 5px 0px;
      }

      &:nth-child(8n),
      &:nth-child(8n-2),
      &:nth-child(8n + 3),
      &:nth-child(8n + 1) {
        background: var(--sprt-8);
      }
    }
  }
}
</style>
